import api from '../api/index';
import {Cascade, Storage, Ticket} from '@/utils';
import Socket from '@/utils/socket'

const actions = {
    updateAppTheme({commit, state}, theme) {
        api.changeUserTheme({theme}).then(res => {
            state.appTheme = theme;
            Ticket.set(Object.assign({}, Ticket.get(), {
                theme
            }))
        });
    },
    getSystemInfo({commit}) {
        api.getSystemInfo().then(res => {
            commit('getSystemInfo', res.package);
        })
    },

    getTrainTypeMenu({commit}) {
        return api.getTrainTypeMenu().then(res => {
            commit('getTrainTypeMenu', res.package);
            return res.package;
        });
    },
    getTrainSpecialMenu({commit}) {
        return api.getTrainSpecial().then(res => {
            commit('getTrainSpecialMenu', res.package);
            return res.package;
        })
    },
    // 注意：因为值中有0，所以对id+1，在组件中要-1后再发请求
    getTrainModeMenu({commit}) {
        return api.getTrainModeMenu().then(res => {
            let data = res.package;
            data.forEach((item,index) => {
                data[index].id = item.id + 1;
            });
            commit('getTrainModeMenu', data);
            return res.package;
        });
    },
    getGroupMenu({commit}) {
        return api.getGroupMenu().then(res => {
            commit('getGroupMenu', res.package);
            return res.package;
        });
    },

    getExamFormMenu({commit}) {
        return api.getExamFormMenu().then(res => {
            commit('getExamFormMenu', res.package);
            return res.package;
        });
    },
    getForLevelMenu({commit}) {
        return api.getForLevelMenu().then(res => {
            commit('getForLevelMenu', res.package);
            return res.package;
        });
    },

    getPositionMenu({commit}) {
        return api.getPostMenu().then(res => {
            commit('getPositionMenu', res.package);
            return res.package;
        });
    },
    getUserTypeMenu({commit}) {
        return api.getUserTypeMenu().then(res => {
            commit('getUserTypeMenu', res.package);
            return res.package;
        });
    },
    getOrgTree({commit}) {
        return api.getOrganizationTree().then((res) => {
            commit('getOrgTree', res.package);
            return res.package
        });
    },
    getCourseTypeMenu({commit}) {
        return api.getCourseTypeMenu().then(res => {
            commit('getCourseTypeMenu', res.package);
            return res.package
        });
    },
    getPaperTypeMenu({commit}) {
        return api.getPaperType().then(res => {
            commit('getPaperTypeMenu', res.package);
            return res.package
        });
    },
    getDifficultyMenu({commit}) {
        return api.getDifficulty().then(res => {
            commit('getDifficultyMenu', res.package);
            return res.package
        });
    },
    getTopicTypeMenu({commit}) {
        return api.getQuestionType().then(res => {
            commit('getTopicTypeMenu', res.package);
            return res.package
        });
    },
    getPaperMethodMenu({commit}) {
        return api.getPaperMethod().then(res => {
            commit('getPaperMethodMenu', res.package);
            return res.package
        });
    },
    /**
     *  知识点下拉菜单
     * @param commit
     * @param type 传'All'，则为全部知识点；传'Image'或'Theory'，则对应图像/理论
     * @param includeSafty 是否包含空包
     */
    getKnowledgeMenu({commit}, {type = 'All', includeSafty = false}) {
        let data = [];

        return api.getKnowledge({
            type,
            includeSafty
        }).then(res => {
            if (res.package.length) {
                data = Cascade.deleteEmptyChild(res.package);
            }

            commit('getKnowledgeMenu', {
                type,
                data
            });

            return data
        });
    },
    //标准图库
    getSystemKnowledgeMenu({commit}, {type = 'All', includeSafty = false}) {
        let data = [];

        return api.getSystemKnowledge({
            type,
            includeSafty
        }).then(res => {
            if (res.package.length) {
                data = Cascade.deleteEmptyChild(res.package);
            }

            commit('getKnowledgeMenu', {
                type,
                data
            });

            return data
        });
    },
    getMarkKnowledgeMenu({commit}) {
        return api.getAnswerType().then(res => {
            let data = Cascade.deleteEmptyChild(res.package)
            commit('getMarkKnowledgeMenu', data);
            return data
        });
    },

    // 注意：因为值中有0，所以对id+1，在组件中要-1后再发请求
    getExamStatusMenu({commit}) {
        return api.getExamStatusMenu().then(res => {
            let data = res.package;
            data.forEach((item,index) => {
                data[index].id = item.id + 1;
            });
            commit('getExamStatusMenu', data);
            return res.package
        });
    },
    getCertTypesMenu({commit}) {
        return api.getCertTypesMenu().then(res => {
            commit('getCertTypesMenu', res.package);
            return res.package
        });
    },
    getPreJobMenu({commit}) {
        return api.getProJobMenu().then(res => {
            commit('getPreJobMenu', res.package);
            return res.package
        });
    },
    getViewCountMenu({commit}) {
        return api.getViewCountMenu().then(res => {
            commit('getViewCountMenu', res.package);
            return res.package
        });
    },
    getProjectTypeMenu({commit}) {
        return api.getProjectTypeMenu().then(res => {
            commit('getProjectTypeMenu', res.package);
            return res.package
        });
    },
    getKnowledgeTypeMenu({commit}) {
        return api.getKnowledgeTypeMenu().then(res => {
            commit('getKnowledgeTypeMenu', res.package);
            return res.package
        });
    },

    //值中有0，在组件中要-1后再发请求
    getImageOriginMenu({commit}) {
        return api.getImageOriginMenu().then(res => {
            let data = res.package;
            data.forEach((item,index) => {
                data[index].id = item.id + 1;
            });
            commit('getImageOriginMenu', res.package);
            return res.package
        });
    },

    getLedgerOriginMenu({commit}) {
        return api.getLedgerOriginMenu().then(res => {
            commit('getLedgerOriginMenu', res.package);
            return res.package
        });
    },

    getYearTimeMenu({commit}) {
        var myDate= new Date();
        var nowYear=myDate.getFullYear();//起始年份
        var lastYear=myDate.getFullYear()-9;//结束年份
        let years = []
        for (var i=lastYear;i<=nowYear;i++)
        {
            years.push({id:i,value:i});
        }
        commit('getYearTimeMenu', years);
        return years
        // return api.getProjectTypeMenu().then(res => {
        //     commit('getProjectTypeMenu', res.package);
        //     return res.package
        // });
    },
    getCreditTypeMenu({commit}) {
        return api.getCreditTypeMenu().then(res => {
            commit('getCreditTypeMenu', res.package);
            return res.package;
        });

    },
    getRankTypeMenu({commit}) {
        return api.getRankTypeMenu().then(res => {
            commit('getRankTypeMenu', res.package);
            return res.package;
        });
    },
    getFiscanProductMenu({commit}) {
        return api.getFiscanProduct().then(res => {
            commit('getFiscanProductMenu', res.package);
            return res.package;
        });
    },

    startWSBrowser({commit}) {
        let socket = new Socket(api.wsBrowserUrl)
        return socket.start().then(() => {
            commit('startWSBrowser', socket.connection);
            return socket.connection
        })
    },
    stopWSBrowser({commit}) {
        commit('stopWSBrowser');
    },
    startWSTrainee({commit}) {
        let socket = new Socket(api.wsTraineeUrl)
        return socket.start().then(() => {
            commit('startWSTrainee', socket.connection);
            return socket.connection
        })
    },
    stopWSTrainee({commit}) {
        commit('stopWSTrainee');
    },
};

export default actions
